import {Assert, Bridge, ToJSON} from "js-vextensions";
import {O, RunInAction_Set} from "web-vcore";
import {EngineConfig} from "../../Server/DB/engineConfigs/@EngineConfig.js";
import {ShakeLevel} from "../../Server/DB/shakes/@Shake.js";
import {HostClientChannel, HostClientChannel_shortNames} from "../../Store/main/engine/config.js";
import {SessionLog} from "../../UI/Tools/@Shared/BetweenSessionTypes/SessionLog.js";
import {PlayShakeLevel, StopShake} from "../../Utils/Bridge/Bridge_Native/SonicBomb.js";
import {RemoteDesktop_DestroyBridgeAndConnection, RemoteDesktop_InitBridge, remoteDesktopBridge} from "../../Utils/Bridge/Bridge_RemoteDesktop.js";
import {processId, remoteUserProcessesBridge} from "../../Utils/Bridge/Bridge_RemoteUserProcesses.js";
import {AppInstanceInfo, GetOwnInstanceInfo} from "../../Utils/Bridge/SiteInstanceBridgeManager.js";
import {liveSession} from "../LiveSessionManagement.js";

export class HostConnection {
	constructor(initialData?: Partial<HostConnection>) {
		
		Object.assign(this, initialData);
	}

	channel: HostClientChannel;
	get ChannelStr() { return ` (through ${HostClientChannel_shortNames[this.channel]} channel)`; }
	hostInfo: AppInstanceInfo;
	//hostProcessID: number;

	bridge: Bridge;
	CreateBridge() {
		// hostConnection.bridge is a level-2 bridge built on top of the level-1 remoteUserProcessesBridge/remoteDesktopBridge
		this.bridge = new Bridge({
			receiveChannelMessageFunc_adder: receiveChannelMessageFunc=>{
				const ReceiveChannelMessageFromHost = (clientProcessId: string, channelMessage)=>{
					if (clientProcessId != processId) return;
					SessionLog(`Receiving message from host${this.ChannelStr}: ${ToJSON(channelMessage)}`);
					receiveChannelMessageFunc(channelMessage);
				};
				if (this.channel == HostClientChannel.RealtimeDatabase) {
					remoteUserProcessesBridge.RegisterFunction("ClientX_ReceiveChannelMessageFromHost", ReceiveChannelMessageFromHost);
				} else {
					remoteDesktopBridge.RegisterFunction("ClientX_ReceiveChannelMessageFromHost", ReceiveChannelMessageFromHost);
				}
			},
			sendChannelMessageFunc: channelMessage=>{
				SessionLog(`Sending message to host${this.ChannelStr}: ${ToJSON(channelMessage)}`);
				// the implementation of HostX_ReceiveChannelMessageFromClient is in ClientConnection.CreateBridge
				if (this.channel == HostClientChannel.RealtimeDatabase) {
					remoteUserProcessesBridge.Call("HostX_ReceiveChannelMessageFromClient", this.hostInfo.processId, channelMessage);
				} else {
					remoteDesktopBridge.Call("HostX_ReceiveChannelMessageFromClient", this.hostInfo.processId, channelMessage);
				}
			},
			channel_wrapBridgeMessage: false,
			channel_stringifyChannelMessageObj: false,
		});

		this.bridge.RegisterFunction("OnActiveHostSessionConfigSet", (config: EngineConfig)=>{
			RunInAction_Set(()=>this.activeHostSessionConfig = config);
		});

		// todo: make sure this is safe from arbitrary code execution
		this.bridge.RegisterFunction("TryCallOnComp", (compTypeName: string, methodName: string, ...methodArgs: any[])=>{
			liveSession!.TryCallOnComp(compTypeName, methodName, ...methodArgs);
		});

		this.bridge.RegisterFunction("SonicBomb_PlayShakeLevel_OnRemote", (shakeLevel: ShakeLevel, strengthMultiplier: number)=>{
			PlayShakeLevel(shakeLevel, strengthMultiplier);
		});
		this.bridge.RegisterFunction("SonicBomb_StopShake_OnRemote", ()=>{
			StopShake();
		});
	}
	DestroyBridge() {
		if (hostConnection!.channel == HostClientChannel.RealtimeDatabase) {
			remoteUserProcessesBridge.UnregisterFunction("ClientX_ReceiveChannelMessageFromHost");
		} else {
			remoteDesktopBridge.UnregisterFunction("ClientX_ReceiveChannelMessageFromHost");
		}
	}

	@O accessor activeHostSessionConfig: EngineConfig;
}
export let hostConnection: HostConnection|n;

/*remoteUserProcessesBridge.RegisterFunction("ConnectToHost", (hostProcessID: number, clientProcessID: number, channel: HostClientChannel)=> {
	if (hostProcessID != processID) return;
	ConnectToHost(clientProcessID, channel);
});*/
export async function ConnectToHost(hostInfo: AppInstanceInfo, channel: HostClientChannel) {
	Assert(hostConnection == null, "Cannot connect to new host when a host is already connected.");
	SessionLog(`Connecting to host: ${ToJSON(hostInfo)}`);

	if (channel == HostClientChannel.Websockets) {
		await RemoteDesktop_InitBridge(hostInfo);
	}

	hostConnection = new HostConnection({hostInfo, channel});
	hostConnection.CreateBridge();

	// now wait for host to connect to us as well
	await remoteUserProcessesBridge.Call("ConnectToClient", hostInfo.processId, GetOwnInstanceInfo(), channel);
}
export async function DisconnectFromHost(tellHostToDisconnect = true) {
	Assert(hostConnection != null, "Cannot disconnect from host when none is connected!");
	SessionLog(`Disconnecting from host: ${ToJSON(hostConnection?.hostInfo)}`);

	const hostConnection_copy = hostConnection;
	hostConnection.DestroyBridge();
	hostConnection = null;

	if (hostConnection_copy.channel == HostClientChannel.Websockets) {
		RemoteDesktop_DestroyBridgeAndConnection();
	}

	// now wait for host to disconnect from us as well
	if (tellHostToDisconnect) {
		await remoteUserProcessesBridge.Call("DisconnectFromClient", hostConnection_copy.hostInfo.processId);
	}
}